// src/pages/Profile.tsx
import React from "react";
import { useAuth } from "../auth/AuthProvider";

const Profile: React.FC = () => {
  const { user } = useAuth();

  if (!user) {
    return <p>로그인 정보가 없습니다.</p>;
  }

  return (
    <div style={{ padding: "20px" }}>
      <h2>프로필 정보</h2>
      <p><strong>ID:</strong> {user.id}</p>
      <p><strong>이름:</strong> {user.name}</p>
      <p><strong>역할:</strong> {user.role}</p>
    </div>
  );
};

export default Profile;
